import React, { CSSProperties } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { useAppSelector } from '../../store/hooks';
import CText from './CText';

interface CHeaderProps {
  title?: string;
  onPressBack?: () => void;
  rightIcon?: React.ReactNode;
  isHideBack?: boolean;
  isLeftIcon?: React.ReactNode;
  color?: string;
  textColor?: string;
  style?: CSSProperties;
}

const CHeader: React.FC<CHeaderProps> = ({
  title,
  onPressBack,
  rightIcon,
  isHideBack = false,
  isLeftIcon,
  color,
  textColor,
  style,
}) => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);

  const goBack = () => navigate(-1);

  return (
    <div
      className="flex justify-between items-center px-4 py-3 mt-2"
      style={style}
    >
      <div className="flex items-center flex-1">
        {!isHideBack && (
          <button
            className="bg-transparent border-none cursor-pointer pr-2 pl-1 flex items-center"
            style={{ color: color || colors.textColor }}
            onClick={onPressBack || goBack}
          >
            {React.createElement(IoArrowBack as any, { size: 24 })}
          </button>
        )}
        {isLeftIcon}
        {title && (
          <CText
            className="flex-1 text-center mr-5 truncate"
            color={textColor || colors.textColor}
            type="B22"
          >
            {title}
          </CText>
        )}
      </div>
      {rightIcon}
    </div>
  );
};

export default React.memo(CHeader);
